<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1><strong>Extract:<br/>
Interesting Karillapig Fact</strong></h1>
<p>The Karillapig’s favourite tree is a dandelion tree. Most dandelion trees on the Moon have secret doors in them where Moon wizards test the quality of cheese. The Karillapig was going to become a wizard but instead decided to become an intrepid explorer.</p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2005ea11